import { useEffect } from "react";
import { useAppStore } from "@/stores/appStore";
import { useReportStore } from "@/stores/reportStore";

export const useReportData = () => {
  const { user } = useAppStore();
  const {
    fetchReportPermissions,
    fetchQueuedReports,
    reportPermissions,
    queuedReports,
    loadingQueuedReports,
    loadingReportPermissions,
  } = useReportStore();
  const isLoading = loadingQueuedReports || loadingReportPermissions;
  useEffect(() => {
    const fetchReportInfo = async () => {
      await fetchReportPermissions(user.user_id);
      await fetchQueuedReports(user.user_id);
    };
    if (user?.user_id) {
      fetchReportInfo();
    }
  }, [user, fetchReportPermissions, fetchQueuedReports]);

  return { reportPermissions, queuedReports, isLoading };
};
